export default __webpack_public_path__ + "static/media/AntyLucy_11.376b8004.jpg";